import { useState } from 'react'
import { useAuth } from '../contexts/AuthContext'
import { useNavigate, Link } from 'react-router-dom'
import { Helmet } from 'react-helmet-async'

const Login = () => {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const { signIn, resetPassword } = useAuth()
  const navigate = useNavigate()

  const handleSubmit = async (e) => {
    e.preventDefault()
    setError('')
    setMessage('')
    try {
      const { error } = await signIn(email, password)
      if (error) throw error
      navigate('/dashboard')
    } catch (error) {
      setError(error.message)
    }
  }

  const handleResetPassword = async (e) => {
    e.preventDefault()
    setError('')
    setMessage('')
    if (!email) {
      setError('กรุณากรอกอีเมลของคุณ')
      return
    }
    try {
      const { error } = await resetPassword(email)
      if (error) throw error
      setMessage('ส่งลิงก์รีเซ็ตรหัสผ่านไปยังอีเมลของคุณแล้ว กรุณาตรวจสอบอีเมล')
    } catch (error) {
      setError(error.message)
    }
  }

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4">
      <Helmet>
        <title>เข้าสู่ระบบ</title>
      </Helmet>
      <div className="max-w-md w-full bg-gray-900 p-8 rounded-lg shadow-xl">
        <h2 className="text-2xl font-bold mb-5 text-white">เข้าสู่ระบบ</h2>
        {error && <div className="bg-red-900/50 text-red-200 p-3 mb-4 rounded border border-red-500">{error}</div>}
        {message && <div className="bg-green-900/50 text-green-200 p-3 mb-4 rounded border border-green-500">{message}</div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label className="block mb-2 text-gray-300">อีเมล</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full p-2 bg-gray-800 border border-gray-700 rounded text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
          </div>
          <div className="mb-4">
            <label className="block mb-2 text-gray-300">รหัสผ่าน</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full p-2 bg-gray-800 border border-gray-700 rounded text-white focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              required
            />
            <button
              type="button"
              onClick={handleResetPassword}
              className="text-blue-400 text-sm mt-2 hover:text-blue-300"
            >
              ลืมรหัสผ่าน?
            </button>
          </div>
          <button
            type="submit"
            className="w-full bg-blue-600 text-white p-2 rounded hover:bg-blue-700 transition-colors mb-4"
          >
            เข้าสู่ระบบ
          </button>
        </form>
        
        <div className="text-center">
          <p className="text-gray-400 mb-2">ยังไม่มีบัญชี?</p>
          <Link 
            to="/register" 
            className="inline-block bg-green-600 text-white px-6 py-2 rounded hover:bg-green-700 transition-colors"
          >
            สมัครสมาชิก
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Login